var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
    'button',
    ("variant-" + _vm.variant),
    ("size-" + _vm.size),
    { 'block': _vm.block },
    { 'disabled': _vm.disabled },
    { 'loading': _vm.loading } ],attrs:{"type":"button","disabled":_vm.disabled || _vm.loading}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('Loader',{staticClass:"loader",attrs:{"size":"small","color":_vm.loaderColor}}):_vm._e(),_c('span',{class:[
    'button-content-container',
    _vm.loading && 'isLoading' ]},[(_vm.image.src)?_c('img',{attrs:{"src":_vm.image.src,"height":"24","width":"24"}}):_vm._e(),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }